import { createContext } from 'react';

let context: any = {
    socket: ''
};

const SocketContext = createContext(context);

export default SocketContext;